import React, { useMemo } from 'react';
import PropTypes, { func } from 'prop-types';
import {
  makeStyles,
  mergeClasses,
  shorthands,
  tokens,
} from '@fluentui/react-components';

import {
  ShortHeadlineAssetCollection,
} from './index';

const assetName = {
  shortHeadline: 'ShortHeadline',
};

const useTextAssetCollectionStyles = makeStyles({
  root: {
    maxWidth: '432px',
  },
  textAssetStyle: {
    '& .text-assets-collection-container': {
      width: '100%',
    },
  },
  textDivider: {
    ...shorthands.margin(tokens.spacingVerticalL, 0),
  },
  hide: {
    display: 'none',
  },
});

const TextAssetCollectionWithCoPilotInternal = (props) => {
  const {
    i18n,
    disableCopilot,
    onResetTextAssets,
    shortHeadlineValidations,
    fetchRecommendationAssets,
    setAddNewShortHeadlinesCallback,
    onChangeTextAssetFormattingSection,
    cancelFetchRecommendationAssetsJob,
  } = props;

  const classes = useTextAssetCollectionStyles();

  const shortHeadlineAssetCollection = useMemo(
    () => (
      <ShortHeadlineAssetCollection
        i18n={i18n}
        className={!shortHeadlineValidations.display ? classes.hide : ''}
        isOptional={false}
        featureName="displayPlus"
        onResetTextAssets={onResetTextAssets}
        enableCopilotRecommendations={!disableCopilot}
        placeholder={shortHeadlineValidations.placeholder}
        isMultipleOptions={shortHeadlineValidations.isMultipleOptions}
        fetchRecommendationAssets={fetchRecommendationAssets}
        setAddNewShortHeadlinesCallback={setAddNewShortHeadlinesCallback}
        cancelFetchRecommendationAssetsJob={cancelFetchRecommendationAssetsJob}
        onToggleTextFormatting={() =>
            onChangeTextAssetFormattingSection(assetName.shortHeadline)
          }
      />
    ),
    [
      i18n,
      classes.hide,
      disableCopilot,
      onResetTextAssets,
      shortHeadlineValidations,
      fetchRecommendationAssets,
      setAddNewShortHeadlinesCallback,
      onChangeTextAssetFormattingSection,
      cancelFetchRecommendationAssetsJob,
    ]
  );

  return (
    <div
      className={mergeClasses(
        'display-template-text-asset-collection',
        classes.root
      )}
    >
      <div
        className={mergeClasses(
          'text-asset-collections',
          classes.textAssetStyle
        )}
      >
        {shortHeadlineAssetCollection}
      </div>
    </div>
  );
};

TextAssetCollectionWithCoPilotInternal.propTypes = {
  i18n: PropTypes.shape({ getString: func, getLocale: func }).isRequired,
  fetchRecommendationAssets: PropTypes.func.isRequired,
  shortHeadlineValidations: PropTypes.shape({
    display: PropTypes.bool,
    placeholder: PropTypes.string,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    isMultipleOptions: PropTypes.bool,
  }),
  onResetTextAssets: PropTypes.func.isRequired,
  disableCopilot: PropTypes.bool.isRequired,
  cancelFetchRecommendationAssetsJob: PropTypes.func.isRequired,
  setAddNewShortHeadlinesCallback: PropTypes.func.isRequired,
  onChangeTextAssetFormattingSection: PropTypes.func.isRequired,
};

TextAssetCollectionWithCoPilotInternal.defaultProps = {
  shortHeadlineValidations: {
    placeholder: '',
    minLength: 0,
    maxLength: 30,
    display: true,
    isMultipleOptions: false,
  },
};

export const TextAssetCollectionWithCoPilot = TextAssetCollectionWithCoPilotInternal;
